export default "__VITE_ASSET__2BFmHn6z__"